import React, { useState, useEffect } from "react";
import { QuestionnairePagePanels } from "./common/QuestionnairePagePanels";

export const QuestionnaireHeader = ({ def }) => {
	const [preamble, setPreamble] = useState();
	const [title, setTitle] = useState();
	const [subTitle, setSubTitle] = useState();
	const [question, setQuestion] = useState();
	const [description, setDescription] = useState();
	const [panels, setPanels] = useState();
	const [headerPanels, setHeaderPanels] = useState();

	useEffect(() => {
		let description;
		if (def.description) {
			description = Array.isArray(def.description)
				? def.description
				: [def.description];
		}

		let preamble;
		if (def.preamble) {
			preamble = Array.isArray(def.preamble) ? def.preamble : [def.preamble];
		}

		let question;
		if (def.question) {
			question = Array.isArray(def.question) ? def.question : [def.question];
		}

		let title;
		if (def.title) {
			title = Array.isArray(def.title) ? def.title : [def.title];
		}

		let subTitle;
		if (def.subTitle) {
			subTitle = Array.isArray(def.subTitle) ? def.subTitle : [def.subTitle];
		}

		let panels;
		if (def.panels) {
			panels = def.panels;
		}

		let headerPanels;
		if (def?.header?.panels) {
			headerPanels = def.header.panels;
		}

		setDescription(description);
		setQuestion(question);
		setTitle(title);
		setSubTitle(subTitle);
		setPreamble(preamble);
		setPanels(panels);
		setHeaderPanels(headerPanels);
	}, [def]);

	return (
		<>
			<div className={"w-full pb-3 xs:pb-6 px-6 text-black text-center"}>
				{preamble &&
					preamble.map((d, index) => {
						return (
							<p className={"text-sm mb-1"} key={`preamble${index}`}>
								{d}
							</p>
						);
					})}
				{title &&
					title.map((d, index) => {
						return (
							<h2 className={"text-xl-eq font-bold mb-1"} key={`title${index}`}>
								{d.toUpperCase()}
							</h2>
						);
					})}
				{subTitle &&
					subTitle.map((d, index) => {
						return <h2 className={"text-lg text-center mb-1"}>{subTitle}</h2>;
					})}
				{question &&
					question.map((d, index) => {
						return (
							<p
								className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}
								key={`title${index}`}
							>
								{d}
							</p>
						);
					})}
				{description &&
					description.map((d, index) => {
						return (
							<p className={"text-sm mb-1"} key={`description_${index}`}>
								{d}
							</p>
						);
					})}
				{headerPanels && <QuestionnairePagePanels panels={headerPanels} />}
				{panels && <QuestionnairePagePanels panels={panels} />}
			</div>
		</>
	);
};
